<template>
  <div id="gHeader">
    <!-- ヘッダー部分 -->
    <!--header-->
    <header role="banner">
      <div class="headInr clearfix">
        <h1><a href="http://www.summersonic.com/2018/"><img src="http://www.summersonic.com/2018/images/cmn_nav_logo.svg" alt="SUMMER SONIC 2018" class="pcNone"></a></h1>
        <div class="navBtn pcNone" @click="clickNavBtn" v-bind:style="{display: menuVisible}"><img src="http://www.summersonic.com/2018/images/cmn_nav_btn_sp.png" alt="メニュー"></div>
      </div>
      <div class="sub-title copyPcNone">
        <p class="title">PDF版タイムテーブルは<a href="http://www.summersonic.com/2018/tt/">こちら</a></p>
      </div>
    </header>
    <!--/header-->
    <!--nav-->
    <nav id="nav" role="navigation" v-bind:class="{ 'open': menuOpen }">
      <ul id="gNav" class="clearfix">
        <li class="navLogo"><a href="http://www.summersonic.com/2018/"><img src="http://www.summersonic.com/2018/images/cmn_nav_logo.svg" alt="SUMMER SONIC 2018"></a></li>
        <li class="navClose" @click="clickNavClose">×</li>
        <li class="navCat"><a href="http://www.summersonic.com/2018/news/"><span>NEWS</span></a>
          <div>
            <ul>
              <li><a href="http://www.summersonic.com/2018/news/">最新ニュース</a></li>
            </ul>
          </div>
        </li>
        <li class="navCat"><a href="http://www.summersonic.com/2018/lineup/"><span>ARTISTS</span></a>
          <div>
            <ul>
              <li><a href="http://www.summersonic.com/2018/lineup/">サマーソニック東京</a></li>
              <li><a href="http://www.summersonic.com/2018/lineup/osaka.html">サマーソニック大阪</a></li>
              <li><a href="http://www.summersonic.com/2018/lineup/mania.html">ソニックマニア</a></li>
              <li><a href="http://www.summersonic.com/2018/lineup/extra.html">サマーソニックエクストラ</a></li>
              <li><a href="http://www.summersonic.com/2018/timetable/">タイムテーブル（WEB版）</a></li>
              <li><a href="http://www.summersonic.com/2018/tt/">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;（PDF版）</a></li>
            </ul>
          </div>
        </li>
        <li class="navCat"><a href="http://www.summersonic.com/2018/tickets/"><span>TICKETS</span></a>
          <div>
            <ul>
              <li><a href="http://www.summersonic.com/2018/tickets/">東京チケット</a></li>
              <li><a href="http://www.summersonic.com/2018/tickets/osaka.html">大阪チケット</a></li>
              <li><a href="http://www.summersonic.com/2018/tickets/mania.html">ソニックマニアチケット</a></li>
              <li><a href="http://www.summersonic.com/2018/tickets/#purchase">チケット購入</a></li>
              <li><a href="http://www.summersonic.com/2018/english/">Purchase tickets outside Japan</a></li>
            </ul>
          </div>
        </li>
        <li class="navCat"><a href="http://www.summersonic.com/2018/info/"><span>INFO</span></a>
          <div>
            <ul>
              <li><a href="http://www.summersonic.com/2018/info/">東京・大阪会場</a></li>
              <li><a href="http://www.summersonic.com/2018/faq/">FAQ</a></li>
              <li><a href="http://www.summersonic.com/2018/info/attention.html">注意事項</a></li>
              <li><a href="http://www.summersonic.com/history/" target="_blank">HISTORY</a></li>
            </ul>
          </div>
        </li>
        <li class="navCat"><a href="http://www.summersonic.com/2018/attractions/"><span>ATTRACTION</span></a></li>
        <li class="navCat"><a href="http://www.summersonic.com/2018/thanks/"><span>SPONSORS</span></a></li>
        <li class="navCat"><a href="http://www.summersonic.com/2018/english/"><span>ENGLISH</span></a></li>
        <li class="navCat"><a href="http://www.summersonic.com/2018/playlists/"><span>PLAYLISTS</span></a></li>
      </ul>
    </nav>
    <!--/nav-->
    <div class="sub-title spNone">
      <p class="title">PDF版タイムテーブルは<a href="http://www.summersonic.com/2018/tt/">こちら</a></p>
    </div>
    <!-- ヘッダー部分 -->
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      menuOpen: false,
      menuVisible: 'visible'
    }
  },
  methods: {
    clickNavBtn () {
      this.menuOpen = true
      this.menuVisible = 'none'
      this.$parent.position = 'fixed'
    },
    clickNavClose () {
      this.menuOpen = false
      this.menuVisible = 'visible'
      this.$parent.position = ''
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/components/parts/Header";
</style>



// WEBPACK FOOTER //
// src/components/parts/Header.vue